import React, { useEffect, useState, useCallback } from 'react';
import { SlidersHorizontal, Check, X } from 'lucide-react';

import {
    getFleetNotifyPrefs,
    setFleetNotifyPrefs,
    FLEET_NOTIFY_CATEGORY_LABELS,
    FLEET_NOTIFY_PREFS_EVENT,
} from '../../utils/fleetNotifyPrefs';
import {
    getNotificationPermission,
    requestNotificationPermission,
} from '../../services/desktopNotify.service';
import { setupFleetWebPush } from '../../services/webPush.service';

const PERMISSION_BADGE = {
    granted: { text: 'AÇIK', color: '#22c55e' },
    denied: { text: 'ENGELLİ', color: '#ef4444' },
    default: { text: 'SORULMADI', color: '#f59e0b' },
    unsupported: { text: 'DESTEKLENMİYOR', color: '#6b7280' },
};

export default function NotificationSettingsPopover() {
    const [open, setOpen] = useState(false);
    const [permission, setPermission] = useState(getNotificationPermission());
    const [prefs, setPrefs] = useState(getFleetNotifyPrefs());

    /* İzin tarayıcı ayarlarından da değişebilir; sekmeye dönüldüğünde tazele. */
    const refreshPermission = useCallback(() => setPermission(getNotificationPermission()), []);

    useEffect(() => {
        const onPrefs = () => setPrefs(getFleetNotifyPrefs());
        window.addEventListener(FLEET_NOTIFY_PREFS_EVENT, onPrefs);
        window.addEventListener('focus', refreshPermission);
        document.addEventListener('visibilitychange', refreshPermission);
        return () => {
            window.removeEventListener(FLEET_NOTIFY_PREFS_EVENT, onPrefs);
            window.removeEventListener('focus', refreshPermission);
            document.removeEventListener('visibilitychange', refreshPermission);
        };
    }, [refreshPermission]);

    const handleRequest = async () => {
        const result = await requestNotificationPermission();
        setPermission(result);
        /* İzin yeni verildiyse token'ı hemen üret — kullanıcı sayfayı yenilemek zorunda kalmasın. */
        if (result === 'granted') setupFleetWebPush().catch(() => {});
    };

    const toggle = (key) => setFleetNotifyPrefs({ [key]: !prefs[key] });

    const badge = PERMISSION_BADGE[permission] || PERMISSION_BADGE.unsupported;

    return (
        <div className="fleet-notify-settings">
            {/* Simge bilinçli olarak zil DEĞİL: soldaki bildirim listesi düğmesi zaten zil;
                iki aynı simge yan yana hangisinin ne yaptığını okunmaz kılıyordu. İzin
                durumu, panel açılmadan da görünsün diye tetikleyicideki nokta ile taşınır. */}
            <button
                type="button"
                className="fleet-notify-settings__trigger"
                onClick={() => setOpen((v) => !v)}
                title={`Bildirim ayarları — ${badge.text}`}
                aria-label={`Bildirim ayarları — ${badge.text}`}
            >
                <SlidersHorizontal size={18} />
                {permission !== 'granted' && (
                    <span className="fleet-notify-settings__dot" style={{ background: badge.color }} />
                )}
            </button>

            {open && (
                <div className="fleet-notify-settings__panel" role="dialog" aria-label="Bildirim ayarları">
                    <div className="fleet-notify-settings__head">
                        <span>Masaüstü bildirimleri</span>
                        <span
                            className="fleet-notify-settings__badge"
                            style={{ background: badge.color }}
                        >
                            {badge.text}
                        </span>
                    </div>

                    {permission === 'default' && (
                        <button type="button" className="fleet-notify-settings__cta" onClick={handleRequest}>
                            Bildirimlere izin ver
                        </button>
                    )}

                    {permission === 'denied' && (
                        <p className="fleet-notify-settings__hint">
                            Tarayıcı bildirimleri engelliyor. Adres çubuğundaki kilit simgesine tıklayın,
                            Site ayarları > Bildirimler bölümünde “İzin ver” seçin, ardından sayfayı yenileyin.
                        </p>
                    )}

                    <ul className="fleet-notify-settings__list">
                        {Object.keys(FLEET_NOTIFY_CATEGORY_LABELS).map((key) => (
                            <li key={key}>
                                <button
                                    type="button"
                                    className="fleet-notify-settings__row"
                                    onClick={() => toggle(key)}
                                    aria-pressed={prefs[key]}
                                >
                                    <span>{FLEET_NOTIFY_CATEGORY_LABELS[key]}</span>
                                    {prefs[key]
                                        ? <Check size={16} color="#22c55e" />
                                        : <X size={16} color="#6b7280" />}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}
